<template>
  <div id="myaccount">
      <stock-header></stock-header>
        
    <div class="market_wrapper">
      <div class="top_bar">
      </div>
      <div class="market_content">
                <stock-rise></stock-rise>

        <ul class="market_right">
          <li style="text-align:center;background: #f0f0f0a8;width: 205px;font-size: 18px;">
            <span>{{$t('pc.allhkstock.us_stock_market')}}</span>
          </li>
          <li @click="changeAccount(1)" style="text-align:left;padding-left:14px;margin-left:9px;" :class="{'active-btn': activeAccount === 1}">
            <router-link to="/stockmarket/allstock">{{$t('pc.allhkstock.all_us_stocks')}}</router-link>
          </li>

          <li style="text-align:left;padding-left:14px;margin-left:2px;">
            <button
              @click="pushSort('chg','desc')"
              :class="{'active-btn': activeSort === 'chg_desc'}"
            >
              {{$t('pc.allhkstock.sort_chg_desc')}}
            </button>
          </li>

          <li style="text-align:left;padding-left:14px;margin-left:2px;">
            <button
              @click="pushSort('chg','asc')"
              :class="{'active-btn': activeSort === 'chg_asc'}"
            >
              {{$t('pc.allhkstock.sort_chg_asc')}}
            </button>
          </li>

          <li style="text-align:left;padding-left:14px;margin-left:2px;">
            <button
              @click="pushSort('totalMarketValue','desc')"
              :class="{'active-btn': activeSort === 'totalMarketValue_desc'}"
            >
              {{$t('pc.allhkstock.sort_market_value_desc')}}
            </button>
          </li>

          <li style="text-align:left;padding-left:14px;margin-left:2px;">
            <button
              @click="pushSort('tradingVolume','desc')"
              :class="{'active-btn': activeSort === 'tradingVolume_desc'}"
            >
              {{$t('pc.allhkstock.sort_volume_desc')}}
            </button>
          </li>

          <li style="text-align:left;padding-left:14px;margin-left:2px;">
            <button
              @click="pushSort('longTradingStocks','desc')"
              :class="{'active-btn': activeSort === 'longTradingStocks_desc'}"
            >
              {{$t('pc.allhkstock.long_trading_stocks')}}
            </button>
          </li>

          <li style="text-align:left;padding-left:14px;margin-left:2px;">
            <button
              @click="pushSort('shortTradingStocks','desc')"
              :class="{'active-btn': activeSort === 'shortTradingStocks_desc'}"
            >
              {{$t('pc.allhkstock.short_trading_stocks')}}
            </button>
          </li>
        </ul>
          <router-view name="kids"></router-view>
      </div>
    </div>
    <keep-alive>
    </keep-alive>
  </div>
</template>
<script>
import "./../assets/css/account.css";
import "./../assets/css/deal.css";
import StockHeader from "@/components/stockheader";
  import StockRise from "@/components/stockrise"

export default {
  name: "Stockmarket",
  data(){
    return{
      activeSort: '',
      activeAccount: 0,
    }
  },
  components: {
      StockHeader,
      StockRise
    },
  mounted() {
  },
  methods: {
    pushSort(field, order) {
      this.activeSort = `${field}_${order}`;
      this.activeAccount = 0; 
      this.$router.push({
        path: '/stockmarket/allstock',
        query: { sort_field: field, sort_order: order, page: 1 }
      });
    },
    isLogin(){
      if (!this.$store.state.loginType){
        this.$router.push({
          path: "/login"
        });
      }
    },
    changeAccount(type) {
      window.sessionStorage.setItem("accountType", type);
      this.activeAccount = type; 
      this.activeSort = '';
      this.$store.state.accountType = type;
    },
  }
};
</script>
<style scoped>
@import url("./../assets/css/account.css");
@import url("./../assets/css/deal.css");
*{
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
}
  .header_wrapper{
    height: 100px;
    width: 100%;
    background-color: #e35353;
    margin-bottom: 10px;
  }
  .header_info{
    min-width: 1000px;
    max-width: 1200px;
    margin: 0 auto;
    height: 100%;
  }
  .portrait{
    margin-top: 10px;
  }
  .header_right{
    color: white;
    height: 100px;
  }
  .line{
    display: block;
    width: 100%;
    height: 1px;
    background: url(../assets/img/line.png) no-repeat;
  }
  .center-nickname{
    font-size: 18px;
    padding-bottom: 10px;
  }
  .last-time{
    padding-top: 10px;
    font-size: 14px;
  }
  .content-flex{
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .top_bar{
    margin-bottom: 10px;
  }

  .market_wrapper {
  width: 100%;
  overflow: hidden;
  margin-bottom: 0;
}

.market_content {
  width: 1203px;
  /*height: 540px;*/
  background: #fff;
  margin: 0 auto 0;
  overflow: hidden;
}

.market_right {
  display: inline-block;
  width: 185px;
  margin: 0;
}

.market_li_active{
  background-color: unset !important;
}

.market_right > li {
  width: 100%;
  box-sizing: border-box;
  font-size: 16px;
  line-height: 45px;
  padding: 0;
  /*text-indent: 56px;*/
  text-align: center;
}

.market_right > li > a {
  color: #333;
  display: block;
}
button {
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  font-size: 14px;
  padding: 4px 6px;
}

button:hover {
  color: #409EFF; /* Optional hover color */
}

.active-btn {
  font-weight: bold;
  color: #409EFF; /* highlight color */
}
</style>



// WEBPACK FOOTER //
// src/components/stockmarket.vue